import { fromFileResponse } from '../models/responseToModel'
import { DocumentFile } from '../models/types'
import { postFileV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function postFile(documentId: number, formData: FormData): Promise<DocumentFile> {
  const response = await postFileV2(formData)
  return fromFileResponse(response, documentId)
}
